import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        borderColor: 'red',
        borderRadius: 5,
        marginBottom: 10,
        width: '99%',
        padding: 10,
    },
    cardRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    header: {
        marginBottom: '20px',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
    },
    titleContainer: {
        display: 'flex'
    },
    redText: {
        marginLeft: '4px',
        color: 'red'
    },
    sendButton: {
        width: '32px',
        height: '32px',
        backgroundColor: 'yellow',
        '&:hover': {
            backgroundColor: 'yellow'
        }
    },
    sendedButton: {
        width: '32px',
        height: '32px',
        backgroundColor: 'green',
        '&:hover': {
            backgroundColor: 'green'
        }
    },
    statusContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    statusContainerTxt: {
        margin: '0 0 0 4px',
        fontWeight: 'bold',
        transition: 'opacity 0.3s ease-in -out'
    }
}))